export const ErrorBoundary = () => {
  return (
    <div className={"flex flex-col gap-6 items-center justify-center h-[100vh]"}>
      <h1 className={"text-2xl"}>Oops!</h1>
      <p>We're sorry, something went wrong. Please refresh the page.</p>
    </div>
  );
}